import React from 'react';
import './TicketBadge.scss';

export type TicketBadgeVariant = 'live' | 'new' | 'social' | 'risk-free' | 'season' | 'default' | 'on-air';

export interface TicketBadgeProps extends React.HTMLAttributes<HTMLElement> {
  variant?: TicketBadgeVariant;
  children: React.ReactNode;
  className?: string;
  showDot?: boolean;
  as?: React.ElementType;
}

export const TicketBadge: React.FC<TicketBadgeProps> = ({ 
  variant = 'default', 
  children, 
  className = '', 
  showDot = false,
  as: Component = 'span',
  ...rest 
}) => {
  return (
    <Component className={`ticket-badge ticket-badge--${variant} ${className}`} {...rest}>
      {showDot && <span className="ticket-badge__dot" />}
      <span className="ticket-badge__content">{children}</span>
    </Component>
  );
};
